import { Injectable } from '@angular/core';
import { CommonService } from '../../service/common.service'
import * as backgroundColor from '../../config/backgroundColor';
import * as toolbox from '../../config/toolbox';
import * as tooltip from '../../config/tootip';
import * as legend from '../../config/legend';
import * as xAxis from '../../config/xAxis';
import * as yAxis from '../../config/yAxis';
import * as series from '../../config/series';

@Injectable({
  providedIn: 'root'
})
export class NoiseEventWaveService {

  constructor(
    private commonService: CommonService
  ) { }

  style = this.commonService.setNoiseDropboxLine();

  //todo 获取默认option
  getDefaultOpitonsOfEventWave = () => {
    let chartOpt = {
      backgroundColor: backgroundColor.backgroundColor,
      grid: this.style.grid,
      toolbox: toolbox.getNoiseEventWaveToolbox(this.style),
      legend: legend.getNoiseDropLineLegend(this.style, []),
      tooltip: tooltip.getNoiseDropLineTooltip(),
      xAxis: xAxis.getXaxisOfNoiseEventWave([], 0, ''),
      yAxis: yAxis.getYaxisOfNoiseDropLine(""),
      series: series.getBasicLineChartSeriesWithoutData()
    }
    return chartOpt
  }

  //todo tooltip显示格式化
  setTooltipFormat(value: string) {
    return tooltip.getNoiseDropLineTooltip(value);
  }


}
